<bor-app-header />
<main class="site-main">
  <router-outlet />
</main>
<bor-app-footer />
